<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-toolbar color="light-blue" dark>
            <v-toolbar-title text-xs-center>Methods</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <catalog :allowAdding="false"></catalog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Catalog from '@/components/Catalog/Catalog'
export default {
  components: {
    Catalog
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Catalog/AppCatalog.vue